/**
 * A rate-card field with its "?" beside it — one placement for every field (STATE-003). TMMPDM-0089:
 * the help that still applies after the wholesale card retired moved here, one short line per field.
 */
import type { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import { HelpPopover } from '@/components/ui';

export function FieldWithHelp({
  children,
  label,
  help,
}: {
  children: ReactNode;
  /** The field's visible label; the trigger's accessible name is "Help for {{label}}". */
  label: string;
  help: string;
}) {
  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: 'flex-start' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      <Box sx={{ pt: 1.25 }}>
        <HelpPopover label={label} short={help} />
      </Box>
    </Stack>
  );
}
